export default __webpack_public_path__ + "static/media/homehero3.345707bf.png";